import { getLocalizedValue as t } from "../i18n";
import { utils as i18nNamespace } from "../i18n/namespace";
export default {
    cidr_v4: {
        regex: /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}\/(3[0-2]|[12]?[0-9])$/,
        get message() { return t("must_be_a_valid_cidr", i18nNamespace); }
    },
    ip_v4: {
        regex: /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/,
        get message() { return t("must_be_a_valid_ip", i18nNamespace); }
    },
    cvoManagementPassword: {
        regex: /^(?=.{0,50}$)(?=[\x21-\x7E]*[0-9])(?=[\x21-\x7E]*[a-zA-Z])(?!.*[#%"?()\/:\[\]\\{}])((?!admin)[\x21-\x7E]){8,}$/,
        message: "Enter a password within 8-50 characters with an English alphabet and a number. Exclude non-English alphabets, the word \"admin\", and : / ( ) { } [ ] # % \" ? \\."
    },
    iamArn: {
        regex: /^arn:((aws)|(aws-us-gov)):iam::[0-9]{12}:role\/[0-9a-zA-Z/_+=,.@-]{1,64}$/,
        get message() { return t("must_be_a_valid_iam_arn", i18nNamespace); }
    },
    awsAccountId: {
        regex: /^[0-9]{12}$/,
        get message() { return t("must_be_a_valid_aws_account_id", i18nNamespace); }
    },
    credentialsName: {
        regex: /^[0-9a-zA-Z][0-9a-zA-Z_+ =,.@-]{0,99}$/,
        get message() { return t("credentials_name_requirements", i18nNamespace); }
    },
    organizationName: {
        regex: /^[^\s]*$/,
        get message() { return t("org_name_requirements", i18nNamespace); }
    },
    connectorName: {
        regex: /^[a-zA-Z][-a-zA-Z0-9]*$/,
        get message() { return t("connector_name_requirements", i18nNamespace); }
    },
    awsWeTagKey: {
        regex: '^(?!aws:)[\\w \\+\\-\\=\\.\\_\\:\\/\\@]{1,127}$',
        message: "Amazon tag keys may not start with 'aws:', must be between 1 and 127 characters long and may contain letters, numbers spaces, or the special characters + - = . _ : / @"
    },
    awsWeTagValue: {
        regex: '^[\\w \\+\\-\\=\\.\\_\\:\\/\\@]{1,255}$',
        message: "Amazon tag values must be between 1 and 255 characters long and may contain letters, numbers spaces, or the special characters + - = . _ : / @"
    },
    azureWeTagKey: {
        regex: '^.{1,512}$',
        message: "Azure tag keys must be between 1 and 512 characters long"
    },
    azureWeTagValue: {
        regex: '^.{0,256}$',
        message: "Azure tag values may not exceed 256 characters"
    },
    gcpWeTagKey: {
        regex: '^[a-z][0-9a-z_\\-]{0,63}$',
        message: 'GCP label keys can include only hyphens (-), underscores (_), lowercase characters, and numbers are allowed. Keys must start with a lowercase character and up to 63 characters.'
    },
    gcpWeTagValue: {
        regex: '^[0-9a-z_\\-]{0,63}$',
        message: 'GCP label values can include Only hyphens (-), underscores (_), lowercase characters, and numbers are allowed. International characters are allowed and up to 63 characters.'
    },
     federationName: {
        regex: /^[0-9a-zA-Z][0-9a-zA-Z_ @-]{1,127}$/,
        get message() { return t("federation_name_requirements", i18nNamespace); }
    },
    dashboardName: {
        regex: /^[0-9a-zA-Z][0-9a-zA-Z_ -]{0,127}$/,
        get message() { return t("dashboard_name_validation", i18nNamespace); }
    },
    cardName: {
        regex: /^[0-9a-zA-Z][0-9a-zA-Z_ -]{0,127}$/,
        get message() { return t("card_name_validation", i18nNamespace); }
    },
    urlPattern: {
        regex: '^https?:\\/\\/[0-9A-Za-z_\\/\\-\\.\\:\\#\\@]*$',
        get message() { return t("url_pattern_requirements", i18nNamespace); }
    },
    fleetName: {
        regex: /^[a-zA-Z0-9][a-zA-Z0-9 _-]{2,119}$/,
        get message() { return t("fleet_name_validation", i18nNamespace); }
    },
    scopeName: {
        regex: /^[a-zA-Z0-9][a-zA-Z0-9 _-]{0,129}$/,
        get message() { return t("name_validation_message", i18nNamespace); }
    },
    ldapName: {
        regex: /^[a-zA-Z0-9][a-zA-Z0-9 _-]*$/,
        get message() { return t("ldap_name_error_message", i18nNamespace); }
    },
    hostOrIp: {
        regex: /^(([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}|(\d{1,3}\.){3}\d{1,3})$/,
        get message() { return t("host_or_ip_error_message", i18nNamespace); }
    },

    federationUrlPattern: {
        regex: '^https?:\\/\\/[0-9A-Za-z\\-._~:/?#\\[\\]@!$&\'()*+,;=%]*$',
        get message() { return t("url_pattern_requirements", i18nNamespace); }
    }
}